import moment from "moment";
import UIkit from "uikit";
import React, { useContext, useState, useEffect, useMemo } from "react";

import { AppContexts } from "../../providers";
import { Image } from "uikit-react";
import ReservationNumber from "../common/ReservationNumber";
import UnitInfo from "../messages/unit-info";

import { host } from "../../http";

const GuestDetails = (props) => {
  const { contact = null, guest_reservations = [], guest = null } = props;
  const threadInfo =
    !guest || guest?.guest_id == "0" ? contact || {} : guest || {};
  const { user } = useContext(AppContexts.AuthContext);

  const [indexes, setIndexes] = useState({
    current: 0,
    upcoming: 0,
    past: 0,
  });
  const [currentReservation, setCurrentReservation] = useState({});

  const sortedReservations = useMemo(() => {
    const current = [],
      upcoming = [],
      past = [];

    const today = moment().startOf("day");
    guest_reservations.forEach((it) => {
      const checkIn = moment(it.check_in, "YYYY-MM-DD");
      const checkOut = moment(it.check_out, "YYYY-MM-DD");

      if (checkIn.isAfter(today)) {
        upcoming.push(it);
      } else if (checkOut.isBefore(today)) {
        past.push(it);

      } else {
        current.push(it);
      }
    });
    return { current, upcoming, past };
  }, [guest_reservations]);

  const incrementIndex = (tab) => {
    const length = sortedReservations[tab].length;
    setIndexes({ ...indexes, [tab]: (indexes[tab] + 1) % length });
  };

  const decrementIndex = (tab) => {
    const length = sortedReservations[tab].length;
    setIndexes({ ...indexes, [tab]: (indexes[tab] - 1 + length) % length });
  };

  const reservationRenderer = (tab) => {
    const reservation = sortedReservations[tab][indexes[tab]];
    if (!reservation) return null;

    return (
      <div className="guest-chat-info-wrapper">
        {sortedReservations[tab].length > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div>
              Booking {indexes[tab] + 1} of {sortedReservations[tab].length}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <span
                uk-icon="arrow-left"
                className="uk-icon-button"
                onClick={() => decrementIndex(tab)}
              ></span>
              <span
                uk-icon="arrow-right"
                className="uk-icon-button"
                onClick={() => incrementIndex(tab)}
              ></span>
            </div>
          </div>
        )}

        {reservation.category === "CXL" && (
          <div className="hms-booking-tag uk-margin-small-top cancelled">
            Cancelled Booking
          </div>
        )}
        <div className="uk-margin-small-top message-text-group">
          <span uk-tooltip="Check-In - Check-Out">
            <Image src="/images/check-in-check-out.svg" />
          </span>
          <div className="chat-value">
            {moment(reservation?.check_in).format("MMM DD, YYYY")} -{" "}
            {moment(reservation?.check_out).format("MMM DD, YYYY")}
          </div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Property ID">
            <Image src="/images/property-id.svg" />
          </span>
          <div className="chat-value">
            {reservation?.pms_id}
            {reservation?.rental_id && (
              <span
                className="guest-detail-more-info uk-margin-small-left"
                uk-tooltip="Property Macros"
                uk-toggle="target: #unit-info-modal"
                onClick={() => {
                  setCurrentReservation(reservation);
                }}
              >
                More Info <Image src="/images/more-info.svg" />
              </span>
            )}
          </div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Address">
            <Image src="/images/address.svg" />
          </span>
          <div className="chat-value">{reservation?.pms_address}</div>
        </div>

        <div className="uk-margin-small message-text-group">
          <span uk-tooltip="Reservation Number">
            <Image src="/images/reservation-number.svg" />
          </span>
          <div className="chat-value">
            <ReservationNumber
              hostID={reservation?.host_id}
              pms={user?.details?.pms}
              resevationID={reservation?.reservation_id}
              nativeID={reservation?.native_id}
            />
          </div>
        </div>

        {reservation?.door_code && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Door Code">
              <Image src="/images/door-code.svg" />
            </span>
            <div className="chat-value">{reservation?.door_code}</div>
          </div>
        )}

        {reservation?.source && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Booking Source">
              <Image src="/images/booking-source.svg" />
            </span>
            <div className="chat-value">{reservation?.source}</div>
          </div>
        )}

        {reservation?.guest_reservation_id && (
          <div className="uk-margin-small message-text-group">
            <span uk-tooltip="Guest Book">
              <Image src="/images/messages-guestbook.svg" />
            </span>
            <div className="chat-value">
              <a
                href={`${host}/v2/reservations/guestbook/${reservation.guest_reservation_id}`}
                target="_blank"
                rel="noreferrer"
              >
                Guestbook
              </a>
            </div>
          </div>
        )}
      </div>
    );
  };

  const getTabsAndContents = () => {
    const tabList = [];
    const contentList = [];

    if (sortedReservations.current.length !== 0) {
      tabList.push(
        <li key="current">
          <a href="#">Current ({sortedReservations.current.length})</a>
        </li>,
      );
      contentList.push(
        <li key="current-content">{reservationRenderer("current")}</li>,
      );
    }
    if (sortedReservations.upcoming.length !== 0) {
      tabList.push(
        <li key="upcoming">
          <a href="#">Upcoming ({sortedReservations.upcoming.length})</a>
        </li>,
      );
      contentList.push(
        <li key="upcoming-content">{reservationRenderer("upcoming")}</li>,
      );
    }

    if (sortedReservations.past.length !== 0) {
      tabList.push(
        <li key="past">
          <a href="#">Past ({sortedReservations.past.length})</a>
        </li>,
      );
      contentList.push(
        <li key="past-content">{reservationRenderer("past")}</li>,
      );
    }

    return { tabList, contentList };
  };

  const { tabList, contentList } = getTabsAndContents();

  useEffect(() => {
    UIkit.tab(".uk-tab", { connect: ".uk-switcher" });
  }, [tabList.length, contentList.length]);

  return (
    <div className="uk-card uk-card-default uk-card-small uk-card-body hms-msg-cards hms-booking-info">
      <div className="message-text-group guest-info" uk-grid>
        <span
          className="message-text-group-icon"
          uk-tooltip={`title: ${threadInfo.category?.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"}; pos: bottom-left; cls: uk-active contact-tooltip`}
        >
          <Image src={`/images/${threadInfo.category || "guest"}-active.svg`} />
        </span>
        <div className="uk-width-expand">
          <div className="guest-chat-info">
            <div className="chat-guest-value">
              {threadInfo.first_name} {threadInfo.last_name}
            </div>
            <div className="chat-guest-value">{threadInfo.formatted_phone}</div>
            <div className="chat-guest-value">{threadInfo.email}</div>
            {!threadInfo.category && (
              <div className="chat-guest-value">
                {guest_reservations.length} booking(s)
              </div>
            )}
          </div>
        </div>
      </div>

      {!threadInfo.category && (
        <div>
          <ul
            className="uk-tab uk-margin-small-top bookings"
            uk-tab="connect: #reservation-switcher"
          >
            {tabList}
          </ul>
          <ul
            id="reservation-switcher"
            className="uk-switcher uk-margin-small-top"
          >
            {contentList}
          </ul>
        </div>
      )}
      <UnitInfo reservation={currentReservation} />
    </div>
  );
};

export default GuestDetails;
